import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { LibOsBasketService } from '@os-components';

export enum BasketItemType {
    SERIAL_NUMBER = 'SERIALNUMBER',
    SPARE_PART = 'SPARE_PART',
    DRIVE_GROUP = 'DRIVEGROUP',
    E_COVER = 'ECOVER',
    CABLE = 'CABLE',
}

export type BasketItem =
    | SerialNumberBasketItem
    | SparePartBasketItem
    | DriveGroupBasketItem
    | ECoverBasketItem
    | CableBasketItem;

export interface Basket {
    searchterm: string;
    items: BasketItem[];
}

export interface SerialNumberBasketItem {
    type: BasketItemType.SERIAL_NUMBER;
    productId: string;
    quantity: number;
}

export interface SparePartBasketItem {
    type: BasketItemType.SPARE_PART;
    productId: string;
    quantity: number;
    isPartOfIndustrialGear: boolean;
}

export interface DriveGroupBasketItem {
    type: BasketItemType.DRIVE_GROUP;
    productId: string;
    driveGroup: string;
    driveGroupNumber: number;
    quantity: number;
}

export interface ECoverBasketItem {
    type: BasketItemType.E_COVER;
    productId: string;
    serialNumber: string;
    isDtcKit: boolean;
    isPainted: boolean;
    quantity: number;
}

export interface CableBasketItem {
    type: BasketItemType.CABLE;
    productId: string;
    quantity: number;
    length: number;
}

export interface BasketTransferData {
    transferGuid: string;
}

export const isSparePartBasketItem = (obj: BasketItem): obj is SparePartBasketItem =>
    obj.type === BasketItemType.SPARE_PART;

@Injectable({
    providedIn: 'root',
})
export class BasketService {
    private http = inject(HttpClient);
    private osBasketService = inject(LibOsBasketService);

    public addProductsToBasket(basketProducts: Basket, callback?: () => void) {
        return this.http.post<BasketTransferData>('/api/basket', basketProducts).subscribe({
            next: (result) => this.osBasketService.addTransferServiceToBasket(result, callback),
            error: (error) => {
                if (callback) {
                    callback();
                }
                console.error('An error occured adding transfer service to basket', error);
            },
        });
    }
}
